var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":"lg"}},[_c('list-package',{attrs:{"selectedPackage":_vm.selectedPackage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }